export const useStyles = () => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      justifyContent: 'center',
      alignItems: 'center',
      marginY: 1,

      '& .MuiTextField-root': {
        width: '100%',
      },
    },
    fieldGroup: {
      gap: 0.5,
      justifyContent: 'start',
      width: '100%',

      '& .MuiTextField-root': {
        width: '100%',
      },

      '& .MuiTypography-root': {
        width: '100%',
        textAlign: 'start',
        fontSize: 14,
      },
    },
  };
};
